import UserApplication from './UserApplication';

export default UserApplication;
